import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { dialogs, site, view } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import ConnectToCmsDialog from '../components/connect-to-cms-dialog';
import { BINDING_ATTRIBUTE } from '../constants/attributes';

function ConnectToCmsDialogContainer({
  elementId,
  elementType,
  onDialogMainAction,
  onDialogCancel,
}) {
  const dispatch = useDispatch();

  const existingBindingId =
    view.accessors.getElementAttribute(elementId, BINDING_ATTRIBUTE) || null;

  const activePageId = useSelector(site.selectors.getActivePageId);
  const bindings = useSelector((state) => site.selectors.getPageBindings(state, activePageId));
  const existingBinding = bindings.find((b) => b.id === existingBindingId) || null;

  const handleCancel = () => {
    onDialogCancel({
      dialogType: dialogTypes.CONNECT_TO_CMS_DIALOG,
    });
    dispatch(dialogs.actions.hide());
  };

  const handleSubmit = (slug) => {
    let bindingId;

    if (existingBindingId) {
      bindingId = existingBindingId;
      dispatch(site.actions.updatePageBinding(activePageId, existingBindingId, { slug }));
    } else {
      const addAction = site.actions.addPageBinding(activePageId, { slug, type: elementType });
      bindingId = addAction.payload.binding.id;
      dispatch(addAction);
    }

    view.operations.setElementAttribute(elementId, BINDING_ATTRIBUTE, bindingId);
    saveSite();
    dispatch(dialogs.actions.hide());

    onDialogMainAction({
      dialogType: dialogTypes.CONNECT_TO_CMS_DIALOG,
      bindingId,
      slug,
    });
  };

  return (
    <ConnectToCmsDialog
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      existingSlug={existingBinding?.slug}
      bindings={bindings}
    />
  );
}

ConnectToCmsDialogContainer.propTypes = {
  elementId: PropTypes.string.isRequired,
  elementType: PropTypes.string.isRequired,
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default ConnectToCmsDialogContainer;
